module.exports = __webpack_public_path__ + "static/media/logo.aca89361.png";